
export function mapDriverDto(data) {
    return {
        kierowca_nazwa: data.name,
        kierowca_telefon: data.phone,
        kierowca_email: data.email,
        kierowca_grupa: data.groupId,
        kierowca_opis_rejon: data.driveType,
        kierowca_opis_poza_rejon: data.driveTypeOutsideZone,
        kierowca_rfid: data.rfidNo,
        kierowca_sapid: data.sapId
    };
}

export function mapNewUserDto(data) {
    return {
        uzytkownik_login: data.username,
        uzytkownik_email: data.email,
        uzytkownik_nazwa: data.name,
        uzytkownik_typ: data.typ,
        uzytkownik_waznosc_hasla: data.expiration,
        auto_id: data.carIds,
        pracuje_do: data.pracuje_do,
        pracuje_od: data.pracuje_od
    };
}

export function mapUserEditDto(data) {
    return {
        uzytkownik_login: data.username,
        uzytkownik_email: data.email,
        uzytkownik_nazwa: data.name,
        uzytkownik_typ: data.typ,
        pracuje_do: data.pracuje_do,
        pracuje_od: data.pracuje_od
    };
}

export function mapCarReportsDto(data) {
    return {
        kwartalny: data.kwartalny,
        miesieczny: data.miesieczny,
        opony: data.opony,
        przeglad_serwis: data.przeglad_serwis,
        przeglad_techniczny: data.przeglad_techniczny,
        tygodniowy: data.tygodniowy,
        ubezpieczenie: data.ubezpieczenie,
        email_prywatny: data.email_prywatny
    };
}

export function mapDeviceSettingsDto(data) {
    delete data["monitorowanie"];
    return data;
}

export function mapCarParametersToIds(data) {
    return {
        toSend: {
        marka_id: data.brand.marka_id,
        model_id: data.model.model_id,
        paliwo_id: data.fuel.paliwo_id,
        skrzynia_id: data.gearbox.skrzynia_id,
        typ_id: data.carType.typ_id,
        sr_zuzycie_paliwa: data.sr_zuzycie_paliwa,
        opis: data.opis,
        kierowca: data.kierowca,
        sap_id: data.sap_id,
        mpk: data.mpk
        },
        toUpdate:{
            marka: data.brand.marka,
            model: data.model.model,
            paliwo: data.fuel.paliwo,
            skrzynia: data.gearbox.skrzynia,
            typ: data.carType.typ,
            oczekiwane_sr_spalanie: data.sr_zuzycie_paliwa,
            opis: data.opis,
            kierowca: data.kierowca,
            sap_id: data.sap_id,
            mpk: data.mpk
        }
    };
}
